export default __webpack_public_path__ + "static/media/hitch_implement_S.f12e882f.svg";